import Base from 'app/collections/base';
import FulfillmentMarketPlaceAccount from 'app/models/fulfillment_marketplace_account';

export default Base.extend({
  model: FulfillmentMarketPlaceAccount,

  initialize(models, { apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;
  },
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_marketplace_accounts.js